import React, {useState} from 'react';
import '../css/Hamburger.css'

export default function Hamburger({open, setOpen}) {
    return(
        <div
            className={`hamburgerContainer${open ? ' open' : ''}`}
            onClick={() => setOpen(!open)}
        >
            <span className="hamburgerTooltip">Hamburger Lookin Hamburger Menu</span>
            <div className="bar top"></div>
            <div className="bar middle"></div>
            <div className="bar bottom"></div>
        </div>
    )
}